import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter as Router } from 'react-router-dom'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'


ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById('app-root')
)

serviceWorkerRegistration.register()
